import { silenceConsoleInProduction } from "./logger";
import { installReportLogCapture } from "./reportLogBuffer";

silenceConsoleInProduction();

// 침묵 처리 뒤에 설치한다. 화면에 찍히지 않는 프로덕션에서도 Report issue 가
// 보낼 로그는 남아야 한다.
installReportLogCapture();
